import {
  Money as MoneyIcon,
  CreditCard as CreditCardIcon,
  Pix as PixIcon,
  AccountBalance as BankTransferIcon,
  Description as BoletoIcon,
  LocalHospital as HealthInsuranceIcon,
  MoreHoriz as OtherIcon,
  Payment as PaymentIcon,
} from '@mui/icons-material';

export const PAYMENT_TYPE_LABELS = {
  1: 'Dinheiro',
  2: 'Cartão de Débito',
  3: 'Cartão de Crédito',
  4: 'PIX',
  5: 'Transferência Bancária',
  6: 'Boleto',
  7: 'Convênio de Saúde',
  99: 'Outro',
};

export function getPaymentTypeLabel(type) {
  return PAYMENT_TYPE_LABELS[type] ?? 'Desconhecido';
}

export function getPaymentTypeIcon(type, props = {}) {
  switch (type) {
    case 1: return <MoneyIcon {...props} />;
    case 2: return <CreditCardIcon {...props} />;
    case 3: return <CreditCardIcon {...props} />;
    case 4: return <PixIcon {...props} />;
    case 5: return <BankTransferIcon {...props} />;
    case 6: return <BoletoIcon {...props} />;
    case 7: return <HealthInsuranceIcon {...props} />;
    case 99: return <OtherIcon {...props} />;
    default: return <PaymentIcon {...props} />;
  }
}
